'use client';

import { ErrorContainer } from '@spikemark/ui/shell/error-container';
export default ErrorContainer;